<div
  *ngIf="config.imgUrl && config.isOneLine"
  [ngClass]="
    isActive
      ? 'box one-line-body active-background'
      : 'box one-line-body disable-background'
  "
  (click)="clicked($event)"
  id="one-line-body"
>
  <img class="one-line-img" [src]="config.imgUrl" />
  <div class="one-line-title">{{ config.title }}</div>
</div>

<div
  *ngIf="config.imgUrl && !config.isOneLine"
  [ngClass]="
    isActive
      ? 'box two-line-body active-background'
      : 'box two-line-body disable-background'
  "
  (click)="clicked($event)"
  id="two-line-body"
>
  <div
    [ngClass]="
      isActive ? 'two-line-title white-color' : 'two-line-title blue-color'
    "
  >
    {{ config.title }}
  </div>
  <div
    [ngClass]="
      isActive
        ? 'two-line-description-no-img white-color'
        : 'two-line-description-no-img black-color'
    "
  >
    {{ config.description }}
  </div>
</div>

<div
  *ngIf="!config.imgUrl && !config.isOneLine"
  [ngClass]="
    isActive
      ? 'box two-line-body active-background'
      : 'box two-line-body disable-background'
  "
  (click)="clicked($event)"
  id="two-line-body-no-img"
>
  <div
    [ngClass]="
      isActive && !config.isDisabled
        ? 'two-line-title-no-img white-color'
        : config.isDisabled
        ? 'two-line-title-no-img dark-color'
        : 'two-line-title-no-img blue-color'
    "
  >
    {{ config.title }}
  </div>
  <div
    [ngClass]="
      isActive && !config.isDisabled
        ? 'two-line-description-no-img white-color'
        : config.isDisabled
        ? 'two-line-description-no-img dark-color'
        : 'two-line-description-no-img black-color'
    "
  >
    {{ config.description }}
  </div>
</div>
